import React, { Component } from 'react';
import animations from './animations';
import NavItem from "../NavItem";

const HOME = 'home';
const WHY = 'intro1';
const WHATIDO = 'intro2';
const WORK = 'intro3';
const CONTACT = 'intro4';

class Navigation extends Component {

    constructor(props) {
        super(props);

        this.state = {
            status: 'closed',
			active: HOME
        };

        //TODO
        // animate depending on active item
        // make animation slide from the top or bottom depending on where the hover is coming from?
    }

    componentDidMount() {
    	animations.handleScroll();
	}

	componentWillUnmount() {
    	if (this.leaveTimer) {
			clearTimeout(this.leaveTimer);
		}
	}

	handleMouseEnter(event) {
		let target = event.currentTarget;
		animations.animateIn(
			this.container,
			target,
			() => this.changeStatus('open'),
			() => this.changeStatus('progress'),
			this.state.status
		);
		this.props.pauseHomeTl();
    }

    handleMouseLeave() {
    	if (this.state.status !== 'progress') {
			animations.animateOut(
				this.container,
				() => this.changeStatus('closed'),
				() => this.changeStatus('progress')
			);
		} else {
    		this.leaveTimer = setTimeout(this.handleMouseLeave.bind(this), 500);
		}
    }

    handleMouseLeaveLink(event) {
    	let target = event.currentTarget;
		animations.animateHoverOut(this.container, target);
    }

    handleClick(event, id, key) {
		event.preventDefault();
		this.handleMouseLeave();
		animations.scrollToSection(id, () => animations.setActiveClass(key));
		this.setState({active: id});
	}

    changeStatus(status) {
        this.setState({status: status});
    }

    active(id) {
    	return this.state.active === id ? 'active' : '';
	}

    render() {
        return (
            <nav
                ref={el => this.container = el}
                className={`${this.state.status} d-none d-lg-block`}
                onMouseLeave={this.handleMouseLeave.bind(this)}
				onMouseEnter={this.handleMouseEnter.bind(this)}
            >
                <div className="progress">
                    {/*<div className="inner" />*/}
                    <div className="progress-items">
						<div className={`progress-item ${this.active(HOME)}`} />
						<div className={`progress-item ${this.active(WHY)}`} />
						<div className={`progress-item ${this.active(WHATIDO)}`} />
						<div className={`progress-item ${this.active(WORK)}`} />
						<div className={`progress-item ${this.active(CONTACT)}`} />
					</div>
                </div>
                <div className="items">
                    <NavItem
                        title="Home"
                        active={this.active(HOME)}
                        svg={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M65.78,97.92H80a5.64,5.64,0,0,0,5.58-5.59V56.49a3,3,0,0,1,3-3h8.26a3.14,3.14,0,0,0,1.9-5.59L51.93,2.74a3.08,3.08,0,0,0-3.81,0L1.23,47.86a3.12,3.12,0,0,0,1.91,5.59H11.4a3,3,0,0,1,3,3V92.33A5.64,5.64,0,0,0,20,97.92H34.27a5.64,5.64,0,0,0,5.59-5.59V69.2a3,3,0,0,1,3-3H57a3,3,0,0,1,3,3V92.33a5.84,5.84,0,0,0,5.71,5.59Z"/></svg>}
                        handleMouseEnter={this.handleMouseEnter.bind(this)}
                        handleMouseLeave={this.handleMouseLeaveLink.bind(this)}
						handleClick={event => this.handleClick(event, HOME, 0)}
                    />
                    <NavItem
                        title="Introduction"
						active={this.active(WHY)}
                        svg={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M13.82,79.84a6.13,6.13,0,0,0,8.78,0l8.09-8.1V93.83A6.15,6.15,0,0,0,36.87,100h26.2a6.14,6.14,0,0,0,6.17-6.17V71.74l8.09,8.09a6.13,6.13,0,0,0,8.78,0l5.35-5.35a6.12,6.12,0,0,0,0-8.77L72.25,46.5A11.47,11.47,0,0,0,64,43.07H35.91a11.47,11.47,0,0,0-8.23,3.43L8.47,65.71a5.79,5.79,0,0,0-1.78,4.38,6.57,6.57,0,0,0,1.78,4.39Z"/><path d="M49.9,38.41A19.21,19.21,0,1,0,30.69,19.2,19.26,19.26,0,0,0,49.9,38.41Z"/></svg>}
                        handleMouseEnter={this.handleMouseEnter.bind(this)}
                        handleMouseLeave={this.handleMouseLeaveLink.bind(this)}
						handleClick={event => this.handleClick(event, WHY, 1)}
                    />
                    <NavItem
                        title="The Stack"
						active={this.active(WHATIDO)}
                        svg={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M98.08,32.7a6,6,0,0,0-8.34,0L76.61,45.84a1.41,1.41,0,0,1-1,.32l-15.7-5.45c-.32,0-.32-.32-.64-.64l-5.45-15.7a1.18,1.18,0,0,1,.32-1L67.31,10.27a5.88,5.88,0,0,0,1.28-6.41A5.6,5.6,0,0,0,63.15.33C54.49.65,46.8,4.5,40.71,10.27a34.16,34.16,0,0,0-8.65,34L1.94,74.68A6.07,6.07,0,0,0,.33,78.85,6.69,6.69,0,0,0,1.94,83L17.64,98.4A6.08,6.08,0,0,0,21.8,100,6.74,6.74,0,0,0,26,98.4L56.1,68.27a33.07,33.07,0,0,0,9.61,1.29,34.17,34.17,0,0,0,24.36-9.94A33.64,33.64,0,0,0,100,37.19a8,8,0,0,0-1.92-4.49Z"/></svg>}
                        handleMouseEnter={this.handleMouseEnter.bind(this)}
                        handleMouseLeave={this.handleMouseLeaveLink.bind(this)}
						handleClick={event => this.handleClick(event, WHATIDO, 2)}
                    />
                    <NavItem
                        title="The Goods"
						active={this.active(WORK)}
                        svg={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M77.6,25.06V14A11,11,0,0,0,66.51,2.89H33.25A11,11,0,0,0,22.17,14V25.06H11.08A11,11,0,0,0,0,36.14V86A11,11,0,0,0,11.08,97.11h77.6A11,11,0,0,0,99.77,86V36.14A11,11,0,0,0,88.68,25.06ZM66.51,14V25.06H33.25V14Z"/></svg>}
                        handleMouseEnter={this.handleMouseEnter.bind(this)}
                        handleMouseLeave={this.handleMouseLeaveLink.bind(this)}
						handleClick={event => this.handleClick(event, WORK, 3)}
                    />
                    <NavItem
                        title="Hit Me Up"
						active={this.active(CONTACT)}
                        svg={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M23.75,98.55A22.65,22.65,0,0,1,11.55,95C5,90.87,1.55,86.11,1.43,81.11c-.37-8,7.19-15,15.37-21.35a10.39,10.39,0,0,1,6.1-1.95c5.37,0,11.22,3.29,15,8.42,1.58-.13,5.49-3.91,6.83-5.37l16.1-16.1c3.54-3.54,5.37-5.86,5.37-6.84a20.46,20.46,0,0,1-8.3-13,10,10,0,0,1,1.83-8C65.84,8.76,72.68,1.44,80.48,1.44c5.25,0,10.13,3.42,14.52,10.25,8.29,12.93,2.19,29.76-18.06,50L61.57,77.08C56.32,82.33,40.1,98.56,23.75,98.56Z"/></svg>}
                        handleMouseEnter={this.handleMouseEnter.bind(this)}
                        handleMouseLeave={this.handleMouseLeaveLink.bind(this)}
						handleClick={event => this.handleClick(event, CONTACT, 4)}
                    />
                </div>

                <svg className="hand hand-open" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M86.85,74.06a42.72,42.72,0,0,1-4.57,2.77,39.62,39.62,0,0,1-11.17,3.74H32.05a4.26,4.26,0,0,1-3.66-3.67,4.06,4.06,0,0,1,1.52-3.41l22.91-1.68a1.76,1.76,0,0,0,1.1-.5h0a1.72,1.72,0,0,0-1.35-2.93L29.17,70.1H23.71a4.1,4.1,0,0,1-3.16-.6,3.15,3.15,0,0,1-1.37-2,3.49,3.49,0,0,1,1.51-3.24l29-2.44a1.73,1.73,0,0,0,1.07-.5,1.7,1.7,0,0,0,.5-1.36,1.72,1.72,0,0,0-1.86-1.57L20.21,60.9h-.1a3.49,3.49,0,0,1-2.48-1,3.52,3.52,0,0,1,2.38-6h.1l29.4.15a1.74,1.74,0,0,0,1.23-.5,1.76,1.76,0,0,0,.51-1.21,1.73,1.73,0,0,0-1.72-1.73l-28.92-.15a3.16,3.16,0,0,1,1-5.76l46.61,0L50.24,30c-.48-.72-2.47-4-1-7.29a7.55,7.55,0,0,1,1.47-2.33h0a1.77,1.77,0,0,1,1-.6c.51,0,1.29,1.3,2,2.58,1.44,2.47,3.42,5.84,7.6,7.76a16.35,16.35,0,0,0,4.72,1.35,48.14,48.14,0,0,1,6,1.36c5.09,1.46,8.77,2.52,12.66,5a23.83,23.83,0,0,1,2.09,1.51V35.11L86.62,35c-4.32-2.81-8.4-4-13.57-5.46a52.55,52.55,0,0,0-6.4-1.45A13.16,13.16,0,0,1,62.8,27c-3.2-1.47-4.72-4.08-6.07-6.37s-2.62-4.47-5.27-4.28c-1.49.11-3.64,1.06-5.38,4.95C43.61,26.8,47.43,32,47.59,32.19l.12.16,10.86,8.89-37.47,0a6.66,6.66,0,0,0-5.3,5.31,6.57,6.57,0,0,0,.94,4.71,7,7,0,0,0-1.55,11,7.8,7.8,0,0,0,1.61,1.21,6.48,6.48,0,0,0-1,4.67,6.56,6.56,0,0,0,2.81,4.18,7.55,7.55,0,0,0,5.6,1.17h1.42A7.15,7.15,0,0,0,25,77.2,7.74,7.74,0,0,0,31.67,84l.24,0,39.65,0A43.37,43.37,0,0,0,83.85,79.9c1.14-.59,2.12-1.17,3-1.72Z"/></svg>
                <svg className="hand hand-rock" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M85.22,74.25a31.14,31.14,0,0,1-21.1,8.18H22.82a4.49,4.49,0,1,1,0-9H53.17a1.17,1.17,0,0,0,0-2.34H46.25a4.49,4.49,0,0,1,0-9h4.31a1.17,1.17,0,1,0,0-2.33H42.39a4.49,4.49,0,1,1,0-9h8.17a1.17,1.17,0,0,0,0-2.34H17.34a4.49,4.49,0,1,1,0-9H71.21a1.17,1.17,0,0,0,0-2.34H54.43c.89-1,2.33-2.61,4.75-5.21a13.74,13.74,0,0,1,20.48.18l5.56,6.29V34.8l-3.77-4.26a16,16,0,0,0-12.12-5.48,16.16,16.16,0,0,0-11.94,5.21c-3.77,4-5.48,5.83-6.11,6.82h-34a6.92,6.92,0,0,0,0,13.83H37.09a6.67,6.67,0,0,0-1.7,4.49,6.91,6.91,0,0,0,5.66,6.73,6.78,6.78,0,0,0-1.8,4.58A6.67,6.67,0,0,0,41,71.21h-18A6.91,6.91,0,0,0,16,78.12h0a6.7,6.7,0,0,0,6.83,6.74H64a33.62,33.62,0,0,0,21.19-7.52Z"/></svg>
            </nav>
        );
    }

}

export default Navigation;


// WEBPACK FOOTER //
// ./src/js/components/Navigation/Navigation.js